import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

function HospProfile() {
    const [formData, setFormData] = useState({
        profile_hosp_name:'',
        profile_hosp_reg_name: '',
        profile_hosp_state: '',
        profile_hosp_phone1: '',
        profile_hosp_phone2: '',
        profile_hosp_address: '',
        profile_hosp_user: '',
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
      });

     

    const [ldata, setLdata] = useState(null);
    const handleChange = (e) => {
       
        const { name, value } = e.target;
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();
        fd.append('profile_hosp_name', formData.profile_hosp_name);
        fd.append('profile_hosp_reg_name', formData.profile_hosp_reg_name);
        fd.append('profile_hosp_state', formData.profile_hosp_state);
        fd.append('profile_hosp_phone1', formData.profile_hosp_phone1);
        fd.append('profile_hosp_phone2', formData.profile_hosp_phone2);
        fd.append('profile_hosp_address', formData.profile_hosp_address);
        fd.append('profile_hosp_user', ldata.user_id);
        
        try {
            const response = await axios.post(AppConst.BASE_URL+AppConst.upProfileUrl1, fd, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            });

            if(response.data.status){
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
                initData();
                 toast.success("Updated successfully");
            }
            else{
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
                toast.error("Update failed");
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
              }));
        }
        
      };
    const initData = async() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            
            if(parsed!=null && parsed!=undefined){
                const fd = new FormData();
                fd.append('profile_hosp_user', 1);
                try {
                    const response = await axios.post(AppConst.BASE_URL+AppConst.getProfileUrl1, fd, {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                    });
                    if(response.data.status){
                        
                        var user_dt = response.data.user_dt;
                        if(user_dt!=null && user_dt!=undefined){
                            setFormData(prev => ({
                                ...prev,
                                profile_hosp_name:user_dt.profile_hosp_name,
                                profile_hosp_reg_name: user_dt.profile_hosp_reg_name,
                                profile_hosp_state: user_dt.profile_hosp_state,
                                profile_hosp_phone1: user_dt.profile_hosp_phone1,
                                profile_hosp_phone2: user_dt.profile_hosp_phone2,
                                profile_hosp_address: user_dt.profile_hosp_address,
                                profile_hosp_user: user_dt.profile_hosp_user,
                              }));
                        }
                    }
                } catch (error) {
                   
                }
            }
        }
      };

    useEffect(() => {
        //console.log('Component mounted');
    
        initData();
    
        return () => {
          //console.log('Component unmounted');
        };
      }, []);
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                {/* <div class="col-xxl-2"></div> */}
                    <div class="col-xxl-12">
                        <div class="card">
                            

                            <div class="card-body">
                                <h5>Hospital Profile</h5>
                                <br/>
                                <div class="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Hospital Name</label>
                                                    <input type="text" name="profile_hosp_name" onChange={handleChange} value={formData.profile_hosp_name} class="form-control" placeholder="Enter your Hospital Name"  required/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="lastNameinput" class="form-label">Hospital Reg. No</label>
                                                    <input type="text" name="profile_hosp_reg_name" onChange={handleChange} value={formData.profile_hosp_reg_name} class="form-control" placeholder="Enter your Hospital Reg. No"  required/>
                                                </div>
                                            </div>
                                           
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="compnayNameinput" class="form-label">State</label>
                                                    <input type="text" name="profile_hosp_state" onChange={handleChange} value={formData.profile_hosp_state} class="form-control" placeholder="Enter State"  required/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Phone 1</label>
                                                    <input type="phone" name="profile_hosp_phone1" onChange={handleChange} value={formData.profile_hosp_phone1} class="form-control" placeholder="Phone 1"  required/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Phone 2</label>
                                                    <input type="phone" name="profile_hosp_phone2" onChange={handleChange} value={formData.profile_hosp_phone2} class="form-control" placeholder="Phone 2"  required/>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Address</label>
                                                    <textarea class="form-control" name="profile_hosp_address" onChange={handleChange} value={formData.profile_hosp_address} placeholder="Address"  required></textarea>
                                                </div>
                                            </div>
                                           
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Submit</button>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                    </form>
                                </div>
                                
                            </div>
                        </div>
                    </div> 
                    {/* <div class="col-xxl-2"></div> */}
                </div>
            </div>
        </div>
    );
}

export default HospProfile;
